import createIcon from '../../createIcon';

/**
 * @component @name Commit
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYuOSAxMUMxNi40NCA4LjcyIDE0LjQyIDcgMTIgN0M5LjU4IDcgNy41NiA4LjcyIDcuMSAxMUgyVjEzSDcuMUM3LjU2IDE1LjI4IDkuNTggMTcgMTIgMTdDMTQuNDIgMTcgMTYuNDQgMTUuMjggMTYuOSAxM0gyMlYxMUgxNi45Wk0xMiAxNUMxMC4zNCAxNSA5IDEzLjY2IDkgMTJDOSAxMC4zNCAxMC4zNCA5IDEyIDlDMTMuNjYgOSAxNSAxMC4zNCAxNSAxMkMxNSAxMy42NiAxMy42NiAxNSAxMiAxNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Commit = createIcon('Commit', [
  [
    'path',
    {
      d: 'M16.9 11C16.44 8.72 14.42 7 12 7C9.58 7 7.56 8.72 7.1 11H2V13H7.1C7.56 15.28 9.58 17 12 17C14.42 17 16.44 15.28 16.9 13H22V11H16.9ZM12 15C10.34 15 9 13.66 9 12C9 10.34 10.34 9 12 9C13.66 9 15 10.34 15 12C15 13.66 13.66 15 12 15Z',
      key: 'xpzsr4',
    },
  ],
]);

export default Commit;
